import { NgForOf } from '@angular/common';
import { Directive, Input, inject } from '@angular/core';
import * as i0 from "@angular/core";
export class QtsTrackByPropDirective {
    constructor() {
        this.ngFor = inject((NgForOf), { self: true });
    }
    set ngForTrackByProp(ngForTrackBy) {
        // setter
        this.ngFor.ngForTrackBy = (index, item) => item[ngForTrackBy];
    }
    static { this.ɵfac = function QtsTrackByPropDirective_Factory(t) { return new (t || QtsTrackByPropDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: QtsTrackByPropDirective, selectors: [["", "ngForTrackByProp", ""]], inputs: { ngForOf: "ngForOf", ngForTrackByProp: "ngForTrackByProp" }, standalone: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QtsTrackByPropDirective, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: '[ngForTrackByProp]',
                standalone: true,
            }]
    }], null, { ngForOf: [{
            type: Input
        }], ngForTrackByProp: [{
            type: Input
        }] }); })();
